import { Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'app-sites-area',
  templateUrl: './sites-area.html',
  styleUrls: ['./sites-area.scss']
})
export class SitesAreaComponent implements OnInit {
  @Input() ptb!: string;
  showSites = false;

  constructor() { }

  ngOnInit(): void {
  }

}
